<template>
  <div class="ma-10">
    <v-dialog
      v-model="showCategoryPopup"
      max-width="400"
      persistent
    >
      <v-card>
        <v-card-title class="modal-title">
          Pilih Kategori
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item
              v-for="category in listCategory"
              :key="category.value"
              @click="selectCategory(category.value)"
              :class="{ 'selected-category': filter.category === category.value }"
            >
              <v-list-item-title>{{ category.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#3b54d9"
            text
            @click="clearCategory"
          >
            Clear Filter
          </v-btn>
          <v-btn
            color="#3b54d9"
            text
            @click="showCategoryPopup = false"
          >
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Loading v-if="isLoading" />
    <Popup
      :message="message"
      v-if="isPopup"
      @close="() => (isPopup = false)"
    />

    <div class="top-container-box">
      <h1>FAQ</h1>
      <div>
        <Button
          icon="+"
          outline
          name="Create FAQ"
          style="background-color: #3b54d9; color: #ffffff; width: 160px"
          @click="() => $router.push('/faq/new')"
        />
      </div>
    </div>
    <v-row>
      <v-col cols="6">
        <div class="action-head">
          <div class="f-search">
            <div>
              <v-text-field
                v-model="filter.question"
                type="text"
                class="f-input"
                placeholder="Search..."
                clearable
                dense
                flat
                solo
                style="
                  padding-top: 5px;
                  padding-left: 5px;
                  width: 448px;
                  border-radius: 14px;
                "
                @input="() => getFaq()"
              ></v-text-field>
            </div>
            <div class="f-search-ic">
              <img
                src="/img/icons/search.png"
                style="width: 100%"
                alt="Search Ic"
              />
            </div>
          </div>
          <v-btn
            class="ml-4"
            color="#3b54d9"
            style="color: #ffffff; border-radius: 10px"
            @click="showCategoryPopup = true"
          >
            Filter Kategori
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <NewTable
      :headers="headers"
      :rows="faqs"
      :currentPage="currentPage"
      :totalPages="total"
      :totalData="totalData"
      :customColumns="customColumns"
      :perPage="perPage"
      :onEdit="editItem"
      :onView="watchItem"
      :onDelete="onDelete"
      :onPageChange="getFaq"
    />
  </div>
</template>

<script>
import Button from "../../../components/Button.vue";
import moment from "moment";
import Loading from "@/components/ilustration/Loading.vue";
import getAuthentification from "@/utils/badrequest.js";
import Popup from "@/components/others/Popup.vue";
import NewTable from "@/components/Tabel.vue";

export default {
  components: {
    Button,
    Loading,
    Popup,
    NewTable,
  },
  data() {
    return {
      isLoading: false,
      currentPage: 1,
      total: 0,
      search: "",
      id: 0,
      message: "",
      showCategoryPopup: false,
      isPopup: false,
      totalData: 0,
      perPage: 10,
      filter: {
        question: "",
        sort_by: "desc",
        category: "",
      },
      listCategory: [
            {
              name: "Kampus Merdeka (Global)",
              value: "KAMPUS_MERDEKA",
            },
            {
              name: "Kampus Merdeka (Magang)",
              value: "MAGANG",
            },
            {
              name: "Prakerja",
              value: "PRAKERJA",
            },
            {
              name: "Home",
              value: "HOME",
            },
            {
              name: "Bootcamp",
              value: "BOOTCAMP",
            },
            {
              name: "Karir",
              value: "CAREER",
            },
            {
              name: "Corporate",
              value: "CORPORATE",
            },
            {
              name: "Talent as a service",
              value: "TALENT_SERVICE",
            },
            {
              name: "Technology Service",
              value: "SERVICES",
            },
          ],
      headers: [
        {
          text: "Pertanyaan",
          field: "question",
          width: 400
        },
        { 
          text: "Kategori", 
          field: "category",
          width: 200
        },
        { 
          text: "Tanggal Dibuat", 
          field: "created_at",
          width: 200
        },
        { 
          text: "Tampil Depan", 
          field: "is_main",
          width: 150
        },
      ],
      faqs: [],
      customColumns: [
        {
          field: 'is_main',
          render: (row) => {
            return `<span style="color: ${row.is_main ? 'green' : 'red'}">${row.is_main ? 'YA': 'TIDAK'}</span>`
          },
        },
      ]
      
    };
  },
  methods: {
    async getFaq(page) {

      if (!page) page = this.currentPage
      else this.currentPage = page

      await this.$crm_http
        .get(`/v1/faq?sort_by=${this.filter.sort_by}&category=${this.filter.category || ""}&question=${this.filter.question || ""}&page=${page}&per_page=${this.perPage}`)
        .then((response) => {
          const res = response.data.data.faqs || []
          this.faqs = res.map((element) => {
            return {
              id: element.id,
              question: element.question,
              category: element.category,
              is_main: element.is_main,
              created_at: this.format_date(element.created_at),
            };
          });
          const t = parseInt(response.data.data.total);
          this.total = Math.ceil(t / this.perPage) || 1;
          this.totalData = response.data.data.total;
        })
        .catch((err) => {
          this.message = err.response.data.data
          this.isPopup = true
        });
    },
    watchItem(id) {
      this.$router.push("/faq/watch/" + id);
    },
    editItem(id) {
      this.$router.push("/faq/edit/" + id);
    },
    async onDelete(id) {
      this.isLoading = true;
      try {
        await this.$crm_http.delete("/v1/faq/" + id);
        this.getFaq();
        this.isLoading = false;
      } catch (err) {
        this.message = err.response.data.data
        this.isPopup = true
        this.isLoading = false;
      }
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("DD-MMM-YYYY");
      }
    },
    onFilter() {
      this.currentPage = 1;
      this.isFilterActive = true;
      this.getFaq();
    },
    updateIsFilterActive() {
      this.isFilterActive = !(
        this.filter.sort_by === "desc" &&
        !this.filter.name &&
        !this.filter.category
      );
    },
    selectCategory(value) {
      this.filter.category = value;
      this.showCategoryPopup = false;
      this.getFaq();
      this.updateIsFilterActive();
    },
    clearCategory() {
      this.filter.category = "";
      this.showCategoryPopup = false;
      this.getFaq();
      this.updateIsFilterActive();
    },
  },
  beforeCreate() {
    getAuthentification();
  },
  mounted() {
    this.getFaq();
  },
};
</script>

<style scoped>
.action-head {
  margin-top: 7px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-title {
  font-weight: bold;
  font-size: 19px;
}
.f-search {
  border: 1px solid #d3d6e1;
  width: 100%;
  height: 48px;
  gap: 10px;
  display: flex;
  border-radius: 10px;
  background-color: white;
}
.f-search-ic {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  margin-right: 18px;
}
.f-input {
  width: 86%;
  background: transparent;
  border: none;
}
.f-input:focus {
  background: transparent;
  border: none;
  outline-width: 0;
}
.top-container-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
.form-input {
  border-radius: 14px !important;
  background-color: transparent !important;
}
.count-data {
  position: relative;
  top: -60px;
  width: 30%;
}
.no-pagination {
  margin-top: 20px;
  margin-left: 5px;
}
.selected-category {
  background-color: #e3f2fd;
  color: #3b54d9;
}
</style>